import { render, staticRenderFns } from "./SendDirectMessage.vue?vue&type=template&id=76338faa&scoped=true&"
import script from "./SendDirectMessage.vue?vue&type=script&lang=js&"
export * from "./SendDirectMessage.vue?vue&type=script&lang=js&"
import style0 from "./SendDirectMessage.vue?vue&type=style&index=0&id=76338faa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76338faa",
  null
  
)

export default component.exports